import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GwCompanyForm } from "./Main";
import {
  useGetGwCompanyQuery,
  useGetGwCompanyContractsQuery,
  useGetDivisionQuery,
} from "../../features/api";
import { GatewayContract } from "../../features/api-interfaces";
import {
  DivisionDict,
  getDivisionItems,
  getDivisionLabel,
} from "../default-constants";

export const Update = () => {
  // 情報取得API呼び出し
  const { code } = useParams();
  const gwCompanyCode = code as string;
  const { data: gatewayCompany, refetch: refetch1 } =
    useGetGwCompanyQuery(gwCompanyCode);
  const {
    data: gatewayContract,
    isFetching,
    refetch: refetch2,
  } = useGetGwCompanyContractsQuery(gwCompanyCode);
  // 共通データを取得
  // 区分取得API呼び出し(親区分コード：3:契約サービス区分コード)
  const { data: contractServiceDivisions } = useGetDivisionQuery("3");

  // 一覧データの加工
  const [listData, setListData] = useState([] as GatewayContract[]);

  useEffect(() => {
    refetch1();
    refetch2();
  }, [refetch1, refetch2]);

  useEffect(() => {
    const contractServiceKbnItems: DivisionDict[] = getDivisionItems(
      contractServiceDivisions
    );
    const gatewayContractList = gatewayContract
      ? gatewayContract.map((item) => ({
          ...item,
          contractServiceName: getDivisionLabel(
            contractServiceKbnItems,
            item.contractServiceCode
          ),
        }))
      : [];
    setListData(gatewayContractList);
  }, [gatewayContract, contractServiceDivisions]);

  return (
    <GwCompanyForm
      gatewayCompanyData={gatewayCompany}
      gatewayCompanyContractData={listData}
      gwCompanyCode={gwCompanyCode}
      isFetching={isFetching}
    />
  );
};
